import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useSDK } from '../../app';
import { styled } from '../../styled';
import { AfterRatingContainer } from '../layout/afterRatingContainer';
import { AfterRatingButton } from './afterRatingButton';
import { AfterRatingHeader } from './afterRatingHeader';
import { AfterRatingText } from './afterRatingText';
import { msgs } from './msgs';

const styles = css`
	display: flex;
	flex-direction: column;
	text-align: center;
`;

const RATING_BOUNDARY = 3;

export const AfterRatingWindow = styled(
	observer(({ className }: { className: string }): ReactElement => {
		const sdk = useSDK();
		const intl = useIntl();
		const ratingText =
			sdk.uiStateStore.rating > RATING_BOUNDARY
				? sdk.welcomeDataStore.data?.showcase.afterHighRateText || intl.formatMessage(msgs.highRate)
				: sdk.welcomeDataStore.data?.showcase.afterLowRateText || intl.formatMessage(msgs.lowRate);

		useEffect(() => {
			return () => {
				sdk.uiStateStore.resetRating();
			};
		}, [sdk.uiStateStore]);

		return (
			<AfterRatingContainer
				onCloseClick={useCallback(() => {
					sdk.uiStateStore.setShowAfterRatingWindow(false);
					sdk.configureChatState();
				}, [sdk])}
			>
				<div className={className}>
					<AfterRatingHeader>
						{sdk.welcomeDataStore.data?.showcase.afterRateTextHead || intl.formatMessage(msgs.header)}
					</AfterRatingHeader>
					<AfterRatingText>{ratingText}</AfterRatingText>
					{sdk.formsStore.isQuestionnaireExists && (
						<AfterRatingButton onClick={sdk.showQuestionnaire}>
							<span>
								{sdk.welcomeDataStore.data?.showcase.questionaryLinkText ||
									intl.formatMessage(msgs.submitQuestionary)}
							</span>
						</AfterRatingButton>
					)}
				</div>
			</AfterRatingContainer>
		);
	})
)(styles);
